
export const modalContent = {
  title: {
    eng: "Contact form",
    esp: "Formulario de contacto"
  },
  firstName: {
    eng: "Name",
    esp: "Nombre"
  },
  lastName: {
    eng: "Last Name",
    esp: "Apellido"
  },
  phone: {
    eng: "Phone",
    esp: "Teléfono"
  },
  email: {
    eng: "Email",
    esp: "Email Corporativo"
  },
  reason: {
    eng: "How can we help you?",
    esp: "¿Cómo podemos ayudarle?"
  },
  subscription :{
    eng: "I am interested to know more about",
    esp: "Me interesa saber más de"
  },
  check1: {
    eng: "Electricity Market Intelligence reports",
    esp: "Reportes de inteligencia de mercado eléctrico"
  },  
  check2: {
    eng: "Medium-term Electricity Market Curves Analysis",
    esp: "Análisis de curvas de mercado eléctrico de mediano plazo"
  }, 
  check3: {
    eng: "Long-term Electricity Market Curves Analysis",
    esp: "Análisis de curvas de mercado eléctrico de largo plazo"
  },
  check4: {
    eng: "Natural Gas Market Intelligence reports",
    esp: "Reportes de inteligencia de mercado de gas natural"
  },
  button: {
    eng: "Send",
    esp: "Enviar"
  },
  subsMessage: {
    eng: "I am interested to know more about",
    esp: "Me interesa saber más de"
  }
}
